module.exports = __webpack_public_path__ + "img/xiaoyu.615f0e33.jpg";